import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { disabledTime } from "rsuite/esm/utils/dateUtils";
import { SITEURLNAME } from "../../utils/Messages";
const TabPanel = ({ getTab, setTab, activityData, loginType }) => {
	console.log("activityData : ", activityData);
	const isChallenge = ()=>{
		let result = false ;
		if(activityData?.hasModuleChallenge && activityData?.isCompleted &&
			activityData?.series?.scenes[activityData?.secScCount-1]?.kc?.every((item)=> item?.attempted)){
				result = true;
		}
		return result;
	}
	return (
		<div className="mytabList mt-3 mb-3">
			<ul>
				<li
					className={`w-33 text-center ${getTab === "Lessons" && "Active_tab"
						} pointer`}
					onClick={() => setTab("Lessons")}
				>
					Lessons
				</li>
				<li
					className={`w-33 text-center ${getTab === "Characters" && "Active_tab"
						} pointer`}
					onClick={() => setTab("Characters")}
				>
					Characters
				</li>
				{/* <li
					className={`w-33 text-center ${getTab === "Reflection" && "Active_tab" 
						} ${!activityData?.isCompleted && "disabledevent"} pointer`}
					onClick={() => {activityData?.isCompleted && setTab("Reflection")}}
				>
					{!activityData?.isCompleted && <span>
							<i class="fa-solid fa-lock-keyhole mr-2"></i>
						</span>
					}
					Reflection
				</li> */}

				<li
				// mytablist
					className={`w-33 text-center ${getTab === "Challenges" && "Active_tab"} pointer`}
					onClick={() => {setTab("Challenges")}}
				// disabled={true}
				>
					{/* {window.location.hostname === SITEURLNAME.urlName && loginType && !isChallenge() && <span>
							<i class="fa-solid fa-lock-keyhole mr-2"></i>
						</span>
					} */}
					Challenge
				</li>
			</ul>
		</div >
	);
};
export default TabPanel;
